export default function formatIntegerBySpace(value: number | undefined) {
    if (value === undefined || value === null) return ''

    // Используем русскую локаль, которая использует пробелы как разделители тысяч
    const formatter = new Intl.NumberFormat('ru-RU', {
        useGrouping: true,
        minimumFractionDigits: 0,
        maximumFractionDigits: 20, // Сохраняем все знаки после запятой, если они есть
    })

    // Заменяем запятую на точку для дробной части (ru-RU использует запятую)
    return formatter.format(value).replace(',', '.')
}
